import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31be7db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-outer flex column justify-center items-center responsive-full-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-lottie q-mx-auto" }, null, -1))
const _hoisted_3 = { class: "text-white text-m-b q-ma-none" }

import { computed, onMounted, ref, watch } from 'vue';
import Lottie from 'lottie-web';
import { useUtilStore } from 'stores/useUtilStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  setup(__props) {

const utilStore = useUtilStore();

const commentIndex = ref(0);
const isLoading = computed(() => utilStore.getLoading);

const loadingComments = [
  '잠시만 기다려 주세요!',
  '페이지를 불러오고 있어요!',
  '페이지를 닫거나 이동하지 마세요!',
];
const loadingSrc = require('src/assets/common/lottie/loading.json');

let startTime: any;

const changeLoadingComment = (timestamp: any) => {
  if (!startTime) startTime = timestamp; // 애니메이션 시작 시간

  const currentTime = timestamp - startTime;

  if (currentTime > 9999) {
    commentIndex.value++;
    startTime = timestamp;
  }

  if (!isLoading.value) return;

  requestAnimationFrame(changeLoadingComment);
};

function activeLoadingLottie() {
  const lottieElement = document.querySelector('.loading-lottie');
  if (lottieElement) {
    Lottie.loadAnimation({
      container: lottieElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loadingSrc,
    });
  }
}

watch(
  () => isLoading.value,
  () => {
    if (isLoading.value) requestAnimationFrame(changeLoadingComment);
  }
);

onMounted(() => activeLoadingLottie());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(loadingComments[commentIndex.value % 3]), 1)
  ]))
}
}

})